import { Inline } from "PFComponents/containers";
import DropDown from "PFComponents/dropdown/dropdown";
import { Icon } from "PFComponents/icon";
import i18n from "PFCore/i18n";
import PropTypes from "prop-types";
import { Component } from "react";

import { getChatSendOnEnter, setChatSendOnEnter } from "./send_on_enter";

export default class ChatListMenu extends Component {
  render() {
    const { markAllRead, handleChange } = this.props;
    const sendsOnEnter = getChatSendOnEnter();

    const options = [];
    const addOption = (id, el, fn) => options.push({ id, displayElement: el || id, item: fn });

    addOption(
      sendsOnEnter ? "_show" : "_hide",
      <Inline alignItems="center">
        {sendsOnEnter && <Icon name="check" size="sm" />}
        {i18n.t("core:chat.menu.pressEnterToSend")}
      </Inline>,
      () => {
        setChatSendOnEnter(!sendsOnEnter);
      }
    );

    addOption("mark_all_read", i18n.t("core:chat.menu.markAllRead"), markAllRead);

    return (
      <DropDown
        style={{
          width: 210,
          minWidth: 210,
          right: 8,
          top: 32,
          maxHeight: 300
        }}
        options={options}
        selectedIndex={-1}
        handleClose={() => {}}
        handleChange={handleChange}
      />
    );
  }
}

ChatListMenu.propTypes = {
  forceUpdateAll: PropTypes.func.isRequired,
  markAllRead: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired
};
